<script lang="ts">
	import type { Product } from "~/api";
	import {
		unableToAddProducts,
		addProduct,
		productRows,
		setMostAppropiateBookingPage,
		mostAppropiateBookingPage,
		unableToFitAdditionalProducts,
		virtualOrder
	} from "~/stores/booking";
	import { blur } from "svelte/transition";
	import CartItem from "./CartItem.svelte";

	// Given Product
	export let product: Product;

	// Is gluten free selected?
	export let glutenFree: boolean = false;
	
	// Inputed notes from the controls
	let notes: string = "";


	// Price of the product
	$: price = product.price + (glutenFree ? 20 : 0);

	// Already  added to the cart
	$: cartItems = $productRows.filter((item) => item.productId == product.id);

	// IsTakeAway does not match
	$: cantTakeAway = !product.availableForTakeAway && ($virtualOrder ? $virtualOrder.isTakeAway : false);

	// Event handlers

	const onCreateProductRow = async (product: Product, price: number) => {
		await addProduct(product, price, notes, glutenFree);

		// Reset notes
		notes = "";
	};
</script>

<article class="notification is-info is-light" in:blur>
	<div class="columns">
		<div class="column is-narrow is-hidden-mobile is-hidden">
			<figure class="image is-128x128 mr-4">
				<img
					alt="bild på {product.name}"
					src="https://bulma.io/images/placeholders/128x128.png"
				/>
			</figure>
		</div>
		<div class="column is-narrow">
			<div class="content">
				<p class="title is-size-4">{product.name}</p>
				<p class="subtitle is-size-5">
					{price} kr
				</p>
			</div>
		</div>
		<div class="column" />
		<div class="column is-half is-align-items-flex-start">
			<div class="content">
				<p class="is-size-5">
					{product.description}
				</p>
			</div>
			<!-- Tags -->
			<div class="tags">
				{#if product.isVegan}
					<span class="tag is-success is-medium is-family-monospace">
						<span class="icon is-small"><ion-icon name="thumbs-up" /></span
						><strong>&nbsp;Vegan</strong>
					</span>
				{/if}
				{#if !product.availableForTakeAway}
					<span class="tag is-primary is-light is-medium is-family-monospace">
						<span class="icon is-small"><ion-icon name="alert-circle-outline" /></span
						><strong>&nbsp;Ej för take away</strong>
					</span>
				{/if}
				{#if product.availableAsGlutenfree}
					<span
						class="tag is-warning is-medium has-hover-effect is-family-monospace is-clickable"
						on:click={() => (glutenFree = !glutenFree)}
						class:is-light={!glutenFree}
					>
						{#if glutenFree}
							<span class="icon"><ion-icon name="checkbox" /></span
							><strong>&nbsp;Glutenfri!</strong>
						{:else}
							<span class="icon"><ion-icon name="square-outline" /></span
							><strong>&nbsp;Glutenfri? (+20kr)</strong>
						{/if}
					</span>
				{/if}
				<span
					class="tag is-info is-medium has-hover-effect is-family-monospace is-clickable"
					on:click={() =>
						(notes = prompt("Skriv in ditt meddelande", notes) ?? "")}
					class:is-light={!notes.length}
				>
					{#if notes.length}
						<strong>"{notes}"</strong>
					{:else}
						<span class="icon"
							><ion-icon name="chatbox-ellipses-outline" /></span
						><strong>&nbsp;Lämna ett meddelande?</strong>
					{/if}
				</span>
			</div>
			<!-- Add to Cart -->
			<button
				class="button is-fullwidth is-primary is-rounded"
				on:click={() => onCreateProductRow(product, price)}
				disabled={cantTakeAway || $unableToAddProducts || $unableToFitAdditionalProducts}
			>
				{#if cantTakeAway}
					<span class="is-italic "
						>Denna pizza kan inte tas med!</span
					>
				{:else if $unableToAddProducts}
					<span class="is-italic "
						>Du kan beställa max 6 pizzor samtidigt</span
					>
				{:else if $unableToFitAdditionalProducts}
					<span class="is-italic "
						>Till din valda tid hinner vi inte mer</span
					>
				{:else}
					<span>Lägg till i kundvagnen</span>
				{/if}
			</button>
		</div>
	</div>
</article>
